export function parseListType<T>(items: any[], parser: (data: any) => T) {
  if (Array.isArray(items)) {
    return items.map(item => parser(item));
  } else {
    return undefined;
  }
}
